<template>
  <div class="coin_picker_container b-radius-12">
    <div
      class="d-flex-row space-between value_setter_container value_setter_area md-row-to-col b-radius-9"
    >
      <div class="d-flex-column gap-5 flex-45">
        <h6 class="regular-xxxl f-w-700 font-family-2 t-white">
          {{ $t("current_drive") }}
        </h6>
        <ValueSetter
          style="margin-top: 18px"
          :min="0"
          :max="levelRange.max - 1"
          v-model="levelRange.min"
          :enforce-step-on-input="true"
          :step="50"
        />
      </div>
      <DoubleRight />
      <div class="d-flex-column flex-45 gap-0">
        <h6 class="regular-xxxl f-w-700 font-family-2 t-white">
          {{ $t("desired_drive") }}
        </h6>
        <!-- <p class="t-grey font-family-2 regular-m">{{ description }}</p> -->
        <ValueSetter
          style="margin-top: 18px"
          :min="levelRange.min + 50"
          :max="5000"
          v-model="levelRange.max"
          :step="50"
          :enforce-step-on-input="true"
        />
      </div>
    </div>
    <DualRangePicker
      :steps="steps"
      :min="0"
      :max="5000"
      v-model="levelRange"
      :step="50"
      :minimum-max="3500"
    />
  </div>
</template>

<script setup>
import DualRangePicker from "./DriveRangePicker.vue";
import DoubleRight from "~/components/icons/DoubleRight.vue";
import ValueSetter from "../../commonpickers/ValueSetter.vue";
const checkoutStore = useCheckoutStore();

const steps = [
  {
    title: "0",
  },
  {
    title: "2500",
  },

  {
    title: "5000",
  },
];

const levelRange = ref({
  min: 0,
  max: 5000,
});

watch(
  levelRange,
  (newVal) => {
    checkoutStore.setDetails({
      ...checkoutStore.getDetails,
      currentDrive: newVal.min,
      desiredDrive: newVal.max,
    });
  },
  { deep: true }
);
</script>

<style lang="scss">
.coin_picker_container {
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 24px;
  padding: 12px;
  border: 1px solid var(--stroke-dark);
  .value_setter_container {
    padding: 18px;
    background: var(--bg-dark, #0e1012);
  }

  @media screen and (max-width: 768px) {
    .value_setter_area {
      svg {
        transform: rotate(90deg);
      }
    }
  }
}
</style>
